import api from "../../../services/axiosConfig";
import createModuleApi from "../../../services/createModuleApi";

const crud = createModuleApi("/instances/skeye/skeyeingest", {
  endpoints: { create: "/add-user" },
});

export const fetchUsers = crud.fetchAll;
export const addUser = crud.create;
export const deleteUser = crud.remove;

export const updateUser = async (userData) => {
  const res = await api.post(
    "/instances/skeye/skeyeingest/update-user",
    userData,
  );
  return res.data;
};
